import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import Client from './Client';

export default function Clients({ clients, biData }) {
    if (!clients.length) { return null; }

    const seller_card_about_me_notable_projects_and_clients_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_notable_projects_and_clients_impression',
        data: clients
    });

    return (
        <WithImpressions value={seller_card_about_me_notable_projects_and_clients_impression} className="list">
            <h3><I18n k="user_page_perseus.seller_profile.clients"/></h3>
            <ul>
                {clients.map((client, idx) =>
                    <Client client={client} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

Clients.propTypes = {
    clients: PropTypes.array,
    biData: PropTypes.object
};

Clients.defaultProps = {
    clients: [],
    biData: {}
};
